module.exports = __webpack_public_path__ + "static/codice-etico-materia3-0cd03aee2dda4d748e624f80bdb3c36b.pdf";